import { TodoKanbanColumn } from './TodoKanbanColumn';
import { TodoCard } from './TodoCard';
import {
  useCompleteEosTodo, useReopenEosTodo,
} from '../hooks/useEosTodoMutations';
import type { EosTodo, EosTodoStatus } from '../types';

interface Props {
  todos: EosTodo[];
  onSelect: (todo: EosTodo) => void;
  ownerLabel: (id: string) => string;
  teamLabel: (id: string | null) => string;
}

const COLUMN_TITLES: Record<EosTodoStatus, string> = {
  open: 'Open',
  done: 'Done',
  cancelled: 'Cancelled',
};

export function TodoKanbanBoard({ todos, onSelect, ownerLabel, teamLabel }: Props) {
  const complete = useCompleteEosTodo();
  const reopen = useReopenEosTodo();

  const byStatus: Record<EosTodoStatus, EosTodo[]> = { open: [], done: [], cancelled: [] };
  for (const t of todos) byStatus[t.status].push(t);

  const handleToggle = (todo: EosTodo) => {
    if (todo.status === 'done') reopen.mutate(todo.id);
    else complete.mutate(todo.id);
  };

  return (
    <div className="flex gap-3 h-full overflow-x-auto pb-2">
      {(['open', 'done', 'cancelled'] as EosTodoStatus[]).map((status) => (
        <TodoKanbanColumn key={status} title={COLUMN_TITLES[status]} count={byStatus[status].length}>
          {byStatus[status].map((todo) => (
            <TodoCard
              key={todo.id}
              todo={todo}
              onSelect={onSelect}
              onToggleComplete={handleToggle}
              ownerLabel={ownerLabel}
              teamLabel={teamLabel}
            />
          ))}
          {byStatus[status].length === 0 && (
            <div className="text-xs text-muted-foreground px-2 py-4 text-center">None</div>
          )}
        </TodoKanbanColumn>
      ))}
    </div>
  );
}
